export const getAuth = state => state.auth;
export const getIsAuth = state => state.auth.isAuth;
export const getUser = state => state.auth.user;